/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Ad from 'models/business/Ad';
import Market from 'models/business/Market';
import EmptyBar from 'components/Common/EmptyBar';
import CardBar from 'components/Common/CardBar';
import API from 'api';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import MarketButton from './MarketButton';
import Styles from './index.module.css';

function SelectMarket({
  ad,
  onChangeAd,
  active,
  onSetActive,
}) {
  const [markets, setMarkets] = useState([]);

  const handleChangeField = (e) => {
    const newAd = ad.clone();
    newAd.marketId = e.target.value;
    const m = markets.find((market) => market.id === e.target.value);
    newAd.injectMarket(m);
    onChangeAd(newAd);
  };

  const getMarketList = async () => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return;
    }
    setMarkets((result.resultData || []).map((m) => new Market(m)));
  };

  const handleChangeMarket = (market) => {
    const newAd = ad.clone();
    newAd.marketId = market.id;
    newAd.injectMarket(market);
    onChangeAd(newAd);
  };

  const useMenuStyles = makeStyles(() => ({
    paper: {
      backgroundColor: '#EAF0FF',
      paddingTop: 0,
      paddingBottom: 0,
    },
    list: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }));

  const useSelectStyles = makeStyles(() => ({
    select: {
      color: '#475E95',
      paddingLeft: 10,
      textAlign: 'left',
      '&:focus': {
        background: '#E4EAF9',
      },
    },
  }));

  const menuClasses = useMenuStyles();
  const selectClasses = useSelectStyles();

  useEffect(() => {
    getMarketList();
  }, []);

  useEffect(() => {
    if (!markets.length || !active || !!ad.market.id) return;
    handleChangeMarket(markets[0]);
  }, [markets, ad, active]);

  const renderEmpty = useMemo(() => (
    // <div className={Styles.buttonContainer}>
    //   {
    //       markets.map((market) => (
    //         <div
    //           className={Styles.buttonItem}
    //           key={`empty-market-${market.id}`}
    //         >
    //           <EmptyBar>
    //             <div
    //               style={{
    //                 display: 'flex',
    //                 flexDirection: 'column',
    //                 justifyContent: 'center',
    //                 paddingLeft: 18,
    //               }}
    //             >
    //               <div
    //                 className={Styles.emptyBarText}
    //               >
    //                 {market.name}
    //               </div>
    //             </div>
    //           </EmptyBar>
    //         </div>
    //       ))
    //     }
    // </div>
    <div className={Styles.buttonContainer}>
      <Select
        disableUnderline
        classes={selectClasses}
        className={Styles.mainContainer}
        onChange={handleChangeField}
        onClick={() => {
          onSetActive();
        }}
        value={ad.marketId}
        style={{ width: '100%', height: '100%' }}
        expanded={active}
        IconComponent={({ style, ...ps }) => (
          <ExpandMoreIcon
            style={{
              fontSize: 36,
              pointerEvents: 'none',
              top: 'unset',
              marginRight: 5,
            }}
            {...ps}
          />
        )}
        MenuProps={{ classes: menuClasses }}
      >
        {
          markets.map((market) => (
            <MenuItem
              key={market.id}
              value={market.id}
              style={{ color: '#475E95' }}
              // className={Styles.menuItem}
            >
              {market.name}
            </MenuItem>
          ))
        }
      </Select>
    </div>
  ));

  const renderSelect = useMemo(() => (
    // <div className={Styles.buttonContainer}>
    //   {
    //     markets.map((market) => (
    //       <MarketButton
    //         key={`render-market-button-${market.id}`}
    //         market={market}
    //         onClick={() => {
    //           handleChangeMarket(market);
    //           onSetActive();
    //         }}
    //         selected={market.id === ad.market.id}
    //         expanded={active}
    //       />
    //     ))
    //   }
    // </div>
    <div className={Styles.buttonContainer}>
      <Select
        disableUnderline
        classes={selectClasses}
        className={Styles.mainContainer}
        onChange={handleChangeField}
        onClick={() => {
          onSetActive();
        }}
        value={ad.marketId}
        style={{ width: '100%', height: '100%' }}
        expanded={active}
        IconComponent={({ style, ...ps }) => (
          <ExpandMoreIcon
            style={{
              fontSize: 36,
              pointerEvents: 'none',
              top: 'unset',
              marginRight: 5,
            }}
            {...ps}
          />
        )}
        MenuProps={{ classes: menuClasses }}
      >
        {
          markets.map((market) => (
            <MenuItem
              key={market.id}
              value={market.id}
              style={{ color: '#475E95' }}
              // className={Styles.menuItem}
            >
              {market.name}
            </MenuItem>
          ))
        }
      </Select>
    </div>
  ));

  return (
    <div>
      <div
        className={classNames(
          Styles.titleText, { [Styles.titleTextExpanded]: active },
        )}
      >
        選擇廣告投放賣場
      </div>
      {!ad.platform && <div className={Styles.emptyBar} />}
      {!!ad.platform && renderSelect}
    </div>
  );
}

SelectMarket.propTypes = {
  active: PropTypes.bool,
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  onSetActive: PropTypes.func,
};

SelectMarket.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  onSetActive: () => {},
  active: true,
};

export default SelectMarket;
